import {timeZone} from "../../../../enums/timeZoneEnum";
import {CustomCheckbox} from "../../../../components/CustomCheckbox";
import SummaryItem from "./SummaryItem";
import {SecurityIcon} from "../../../../components/buttons/IconButtons";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 30 de 04 de 2026
 */

const SummaryContainerOptions = ({data,t}) => {

    const textItem = [
        {
            label: 'time_zone',
            value: t(timeZone[data?.timeZoneValue])
        }
    ];
    const itemsA = [
        {
            label: 'show_weapon',
            value: data?.showWeapon
        },
        {
            label: 'turn_on_led',
            value: data?.showLed
        },
        {
            label: 'show_last_access',
            value: data?.showLastAccess
        },
        {
            label: 'show_user_list',
            value: data?.showUserList
        },
        {
            label: 'playSound',
            value: data?.playSounds
        }
    ];
    const itemsB = [
        {
            label: 'show_vehicle',
            value: data?.showVehicle
        },
        {
            label: 'show_access_dialog',
            value: data?.showAccessDialog
        },
        {
            label: 'show_logos',
            value: data?.showLogo
        },
        {
            label: 'synchronize_photographs',
            value: data?.synchorizeSelfies
        },
    ];

    return (
         <div className={"row p-12px"}>
            <div className={"maxw-5 col-1 p-0 d-none d-md-block"}>
                <div className='background-primary-100 p-8px border-radius-8px d-flex justify-content-center
                align-items-center w-44px h-44px'>
                    <SecurityIcon width={24} height={24}/>
                </div>
            </div>
         <div className={" col-12 col-md-11 row p-0"}>
            <div className={"col-12 col-md-6 gap-12px d-flex flex-column"}>
                {itemsB.map((item) => (
                    <CustomCheckbox
                        marginbutton={true}
                        checked={item.value}
                        value={item.value}
                        label={item.label}
                        trans={item.label}
                        name={item.label}
                        disabled={true}
                    />
                ))}
                {textItem.map((item) => (
                    <SummaryItem
                        label={item.label}
                        value={item.value}
                        t={t}
                    />
                ))}
            </div>
            <div className={"col-12 col-md-6 gap-12px d-flex flex-column"}>
                {itemsA.map((item) => (
                    <CustomCheckbox
                        marginbutton={true}
                        checked={item.value}
                        value={item.value}
                        label={item.label}
                        trans={item.label}
                        name={item.label}
                        disabled={true}
                    />
                ))}
            </div>
            </div>
        </div>
    )

}

export default SummaryContainerOptions
